import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ProductoRepository } from 'src/app/domain/service/producto/producto-repository';
import { FiltrosProducto, Producto } from 'src/app/domain/model/producto/producto';

/**
 * Adaptador HTTP: HttpProductoRepository
 *
 * Implementa el puerto ProductoRepository para comunicación con servicios-ms.
 * Endpoint: GET /api/servicios/productos
 *
 * @author Sura - Migración GWT a Angular
 */
@Injectable({ providedIn: 'root' })
export class HttpProductoRepository implements ProductoRepository {

  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.backend.baseUrl}/servicios/productos`;
  private static readonly PAGE_SIZE_MIN = 1;
  private static readonly PAGE_SIZE_MAX = 100;
  private static readonly DEFAULT_PAGE = 0;
  private static readonly DEFAULT_SIZE = 10;

  async buscarProductos(filtros: FiltrosProducto): Promise<Producto[]> {
    const params = this.buildParams(filtros);
    return firstValueFrom(
      this.http.get<Producto[]>(this.baseUrl, { params })
    );
  }

  async contarProductos(filtros: FiltrosProducto): Promise<number> {
    const params = this.buildParams(filtros);
    return firstValueFrom(
      this.http.get<number>(`${this.baseUrl}/count`, { params })
    );
  }

  private buildParams(filtros: FiltrosProducto): HttpParams {
    const page = filtros.page ?? HttpProductoRepository.DEFAULT_PAGE;
    const size = filtros.size ?? HttpProductoRepository.DEFAULT_SIZE;
    this.validarPaginacion(page, size);

    let params = new HttpParams();
    if (filtros.cdproducto?.trim()) params = params.set('cdproducto', filtros.cdproducto.trim());
    if (filtros.dsproducto?.trim()) params = params.set('dsproducto', filtros.dsproducto.trim());
    if (filtros.cdtarea?.trim()) params = params.set('cdtarea', filtros.cdtarea.trim());
    if (filtros.cdclasificacion?.trim()) params = params.set('cdclasificacion', filtros.cdclasificacion.trim());
    params = params.set('page', String(page));
    params = params.set('size', String(size));
    return params;
  }

  private validarPaginacion(page: number, size: number): void {
    if (!Number.isInteger(page) || page < 0) {
      throw new Error('page debe ser mayor o igual a cero.');
    }
    if (!Number.isInteger(size) || size < HttpProductoRepository.PAGE_SIZE_MIN || size > HttpProductoRepository.PAGE_SIZE_MAX) {
      throw new Error(
        `size debe estar entre ${HttpProductoRepository.PAGE_SIZE_MIN} y ${HttpProductoRepository.PAGE_SIZE_MAX}.`
      );
    }
  }
}
